// Based on ngx-touch-keyboard.
// https://github.com/mohsen77sk/angular-touch-keyboard/blob/master/projects/ngx-touch-keyboard/

import { Overlay, OverlayRef, OverlaySizeConfig, PositionStrategy } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ComponentRef, Directive, effect, ElementRef, HostListener, inject, input, model, OnDestroy, OnInit, output, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

export interface Layout {
  // A mapping of keys to their respective 2D array of strings.
  [key: string]: Array<Array<string>>;
}

// Represents a display configuration where each key is associated with a string value.
export interface Display { [key: string]: string; }
//  Represents a locale configuration for the touch keyboard.
export interface Locale {
  code: string;
  dir: 'ltr' | 'rtl';
  layouts: Layout;
  display: Display;
}

export const fnButton = { DONE: `{done}`, ENTER: `{enter}`, SHIFT: `{shift}`, BACKSPACE: `{backspace}`, LANGUAGE: `{language}`, SPACE: `{space}`, TAB: `{tab}`, };
export const fnDisplay = {
  DONE: `<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24"><path d="m12 15-5-5h10Z"/></svg>`,
  ENTER: `<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24"><path d="m9 18-6-6 6-6 1.4 1.4L6.8 11H19V7h2v6H6.8l3.6 3.6Z"/></svg>`,
  SHIFT: `<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24"><path d="M10.8796773,2.4676627 C10.7983669,2.53542133 10.7233714,2.61041687 10.6556128,2.69172724 L2.79065437,12.1296773 C2.17191723,12.8721619 2.27223434,13.9756501 3.01471891,14.5943872 L3.15432027,14.6993778 C3.44275103,14.8945506 3.78413686,15 4.13504161,15 L6.999,15 L7,20.25 C7,21.2164983 7.78350169,22 8.75,22 L15.25,22 L15.3935272,21.9941988 C16.2928897,21.9211923 17,21.1681734 17,20.25 L16.999,15 L19.8649584,15 C20.8314567,15 21.6149584,14.2164983 21.6149584,13.25 C21.6149584,12.8406111 21.47143,12.4441786 21.2093456,12.1296773 L13.3443872,2.69172724 C12.7600244,1.99049181 11.7432755,1.8620539 11.0066223,2.37118457 L10.8796773,2.4676627 Z M12.1920553,3.65200384 L20.0570137,13.0899539 C20.0944543,13.1348827 20.1149584,13.1915159 20.1149584,13.25 C20.1149584,13.3880712 20.0030296,13.5 19.8649584,13.5 L16.25,13.5 C15.8357864,13.5 15.5,13.8357864 15.5,14.25 L15.5,20.25 C15.5,20.3880712 15.3880712,20.5 15.25,20.5 L8.75,20.5 C8.61192881,20.5 8.5,20.3880712 8.5,20.25 L8.5,14.25 C8.5,13.8357864 8.16421356,13.5 7.75,13.5 L4.13504161,13.5 C4.07655749,13.5 4.01992426,13.4794959 3.97499551,13.4420553 C3.86892629,13.3536643 3.85459527,13.1960231 3.94298629,13.0899539 L11.8079447,3.65200384 C11.8176245,3.64038807 11.8283381,3.62967442 11.8399539,3.61999462 C11.9460231,3.5316036 12.1036643,3.54593461 12.1920553,3.65200384 Z"></path></svg>`,
  BACKSPACE: `<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24"><path d="M18.75,4 C20.4830315,4 21.8992459,5.35645477 21.9948552,7.06557609 L22,7.25 L22,16.75 C22,18.4830315 20.6435452,19.8992459 18.9344239,19.9948552 L18.75,20 L10.2488122,20 C9.48467584,20 8.74731983,19.7308489 8.16441163,19.243553 L8.00936186,19.1052839 L3.01367221,14.3552839 C1.71288481,13.1184697 1.66102433,11.0613371 2.89783857,9.76054971 L3.01367221,9.64471607 L8.00936186,4.89471607 C8.56313355,4.36817906 9.28295917,4.05514987 10.0411712,4.00663485 L10.2488122,4 L18.75,4 Z M18.75,5.5 L10.2488122,5.5 C9.85605678,5.5 9.47644043,5.63205173 9.16975262,5.87226779 L9.04295431,5.98177019 L4.04726465,10.7317702 L3.98489269,10.7941421 C3.3580909,11.4533647 3.34595643,12.473346 3.93064574,13.1462921 L4.04726465,13.2682298 L9.04295431,18.0182298 C9.32758521,18.2888625 9.69368599,18.4547433 10.0814672,18.4919848 L10.2488122,18.5 L18.75,18.5 C19.6681734,18.5 20.4211923,17.7928897 20.4941988,16.8935272 L20.5,16.75 L20.5,7.25 C20.5,6.3318266 19.7928897,5.57880766 18.8935272,5.5058012 L18.75,5.5 Z M11.4462117,8.39705176 L11.5303301,8.46966991 L14.000116,10.939 L16.4696699,8.46966991 C16.7625631,8.1767767 17.2374369,8.1767767 17.5303301,8.46966991 C17.7965966,8.73593648 17.8208027,9.15260016 17.6029482,9.44621165 L17.5303301,9.53033009 L15.061116,12 L17.5303301,14.4696699 C17.8232233,14.7625631 17.8232233,15.2374369 17.5303301,15.5303301 C17.2640635,15.7965966 16.8473998,15.8208027 16.5537883,15.6029482 L16.4696699,15.5303301 L14.000116,13.061 L11.5303301,15.5303301 C11.2374369,15.8232233 10.7625631,15.8232233 10.4696699,15.5303301 C10.2034034,15.2640635 10.1791973,14.8473998 10.3970518,14.5537883 L10.4696699,14.4696699 L12.939116,12 L10.4696699,9.53033009 C10.1767767,9.23743687 10.1767767,8.76256313 10.4696699,8.46966991 C10.7359365,8.20340335 11.1526002,8.1791973 11.4462117,8.39705176 Z"></path></svg>`,
  LANGUAGE: `<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24"><path d="M12 22q-2.05 0-3.875-.788-1.825-.787-3.187-2.15-1.363-1.362-2.15-3.187Q2 14.05 2 12q0-2.075.788-3.887.787-1.813 2.15-3.175Q6.3 3.575 8.125 2.787 9.95 2 12 2q2.075 0 3.887.787 1.813.788 3.175 2.151 1.363 1.362 2.15 3.175Q22 9.925 22 12q0 2.05-.788 3.875-.787 1.825-2.15 3.187-1.362 1.363-3.175 2.15Q14.075 22 12 22Zm0-2.05q.65-.9 1.125-1.875T13.9 16h-3.8q.3 1.1.775 2.075.475.975 1.125 1.875Zm-2.6-.4q-.45-.825-.787-1.713Q8.275 16.95 8.05 16H5.1q.725 1.25 1.812 2.175Q8 19.1 9.4 19.55Zm5.2 0q1.4-.45 2.487-1.375Q18.175 17.25 18.9 16h-2.95q-.225.95-.562 1.837-.338.888-.788 1.713ZM4.25 14h3.4q-.075-.5-.113-.988Q7.5 12.525 7.5 12t.037-1.012q.038-.488.113-.988h-3.4q-.125.5-.188.988Q4 11.475 4 12t.062 1.012q.063.488.188.988Zm5.4 0h4.7q.075-.5.113-.988.037-.487.037-1.012t-.037-1.012q-.038-.488-.113-.988h-4.7q-.075.5-.112.988Q9.5 11.475 9.5 12t.038 1.012q.037.488.112.988Zm6.7 0h3.4q.125-.5.188-.988Q20 12.525 20 12t-.062-1.012q-.063-.488-.188-.988h-3.4q.075.5.112.988.038.487.038 1.012t-.038 1.012q-.037.488-.112.988Zm-.4-6h2.95q-.725-1.25-1.813-2.175Q16 4.9 14.6 4.45q.45.825.788 1.712.337.888.562 1.838ZM10.1 8h3.8q-.3-1.1-.775-2.075Q12.65 4.95 12 4.05q-.65.9-1.125 1.875T10.1 8Zm-5 0h2.95q.225-.95.563-1.838.337-.887.787-1.712Q8 4.9 6.912 5.825 5.825 6.75 5.1 8Z"/></svg>`,
  SPACE: ` `,
  TAB: `<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24"><path d="m12 18-1.425-1.4 3.6-3.6H2v-2h12.175L10.6 7.4 12 6l6 6Zm8 0V6h2v12Z"/></svg>`,
};


const defaultLocale: Locale = {
  code: 'en-GB',
  dir: 'ltr',
  layouts: {
    text_alphabetic: [
      ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '{backspace}'],
      ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
      ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l'],
      ['{shift}', 'z', 'x', 'c', 'v', 'b', 'n', 'm', '{enter}'],
      ['{numeric}', '.', '{space}', '{done}'],
    ],
    text_shift: [
      ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '{backspace}'],
      ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
      ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'],
      ['{shift}', 'Z', 'X', 'C', 'V', 'B', 'N', 'M', '{enter}'],
      ['{numeric}', '.', '{space}', '{done}'],
    ],
    text_numeric: [
      ['1', '2', '3'],
      ['4', '5', '6'],
      ['7', '8', '9'],
      ['{symbolic}', '.', '0', '{backspace}'],
      ['{alphabetic}', '{space}', '{done}'],
    ],
    text_symbolic: [
      ['[', ']', '{', '}', '#', '%', '^', '*', '+', '='],
      ['-', '/', ':', ';', '(', ')', '$', '&', '@', '"'],
      ['_', '\\', '|', '~', '<', '>', '€', '£', '¥', '•'],
      ['{numeric}', '.', ',', '?', '!', "'", '{backspace}'],
      ['{alphabetic}', '{space}', '{done}'],
    ],
    // text_numeric: [
    //   ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
    //   ['-', '/', ':', ';', '(', ')', '$', '&', '@', '"'],
    //   ['{symbolic}', '.', ',', '?', '!', "'", '{backspace}'],
    //   ['{alphabetic}', '{space}', '{done}'],
    // ],
    // text_symbolic: [
    //   ['[', ']', '{', '}', '#', '%', '^', '*', '+', '='],
    //   ['_', '\\', '|', '~', '<', '>', '€', '£', '¥', '•'],
    //   ['{numeric}', '.', ',', '?', '!', "'", '{backspace}'],
    //   ['{alphabetic}', '{space}', '{done}'],
    // ],
    search_alphabetic: [
      ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
      ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l'],
      ['{shift}', 'z', 'x', 'c', 'v', 'b', 'n', 'm', '{backspace}'],
      ['{numeric}', '{space}', '{done}'],
    ],
    search_shift: [
      ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
      ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'],
      ['{shift}', 'Z', 'X', 'C', 'V', 'B', 'N', 'M', '{backspace}'],
      ['{numeric}', '{space}', '{done}'],
    ],
    search_numeric: [
      ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
      ['-', '/', ':', ';', '(', ')', '$', '&', '@', '"'],
      ['{symbolic}', '.', ',', '?', '!', "'", '{backspace}'],
      ['{alphabetic}', '{space}', '{done}'],
    ],
    search_symbolic: [
      ['[', ']', '{', '}', '#', '%', '^', '*', '+', '='],
      ['_', '\\', '|', '~', '<', '>', '€', '£', '¥', '•'],
      ['{numeric}', '.', ',', '?', '!', "'", '{backspace}'],
      ['{alphabetic}', '{space}', '{done}'],
    ],
    email_alphabetic: [
      ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
      ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l'],
      ['{shift}', 'z', 'x', 'c', 'v', 'b', 'n', 'm', '{backspace}'],
      ['{numeric}', '@', '{space}', '.', '{done}'],
    ],
    email_shift: [
      ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
      ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'],
      ['{shift}', 'Z', 'X', 'C', 'V', 'B', 'N', 'M', '{backspace}'],
      ['{numeric}', '@', '{space}', '.', '{done}'],
    ],
    email_numeric: [
      ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
      ['$', '!', '~', '&', '=', '#', '[', ']'],
      ['{symbolic}', '.', '_', '-', '+', '{backspace}'],
      ['{alphabetic}', '@', '{space}', '.', '{done}'],
    ],
    email_symbolic: [
      ['`', '|', '{', '}', '?', '%', '^', '*', '/', "'"],
      ['$', '!', '~', '&', '=', '#', '[', ']'],
      ['{numeric}', '.', '_', '-', '+', '{backspace}'],
      ['{alphabetic}', '@', '{space}', '.', '{done}'],
    ],
    url_alphabetic: [
      ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
      ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l'],
      ['{shift}', 'z', 'x', 'c', 'v', 'b', 'n', 'm', '{backspace}'],
      ['{numeric}', '/', '.com', '.', '{done}'],
    ],
    url_shift: [
      ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
      ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'],
      ['{shift}', 'Z', 'X', 'C', 'V', 'B', 'N', 'M', '{backspace}'],
      ['{numeric}', '/', '.com', '.', '{done}'],
    ],
    url_numeric: [
      ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
      ['@', '&', '%', '?', ',', '=', '[', ']'],
      ['{symbolic}', '_', ':', '-', '+', '{backspace}'],
      ['{alphabetic}', '/', '.com', '.', '{done}'],
    ],
    url_symbolic: [
      ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
      ['*', '$', '#', '!', "'", '^', '[', ']'],
      ['{numeric}', '~', ';', '(', ')', '{backspace}'],
      ['{alphabetic}', '/', '.com', '.', '{done}'],
    ],
    numeric_default: [
      ['1', '2', '3'],
      ['4', '5', '6'],
      ['7', '8', '9'],
      ['0', '{backspace}'],
    ],
    decimal_default: [
      ['1', '2', '3'],
      ['4', '5', '6'],
      ['7', '8', '9'],
      ['.', '0', '{backspace}'],
    ],
    tel_default: [
      ['1', '2', '3', '*'],
      ['4', '5', '6', '#'],
      ['7', '8', '9', '+'],
      ['0', '{backspace}'],
    ],
  },
  display: {
    '{done}': fnDisplay.DONE,
    '{shift}': fnDisplay.SHIFT,
    '{backspace}': fnDisplay.BACKSPACE,
    '{enter}': fnDisplay.ENTER,
    '{space}': fnDisplay.SPACE,
    '{alphabetic}': 'ABC',
    '{numeric}': '123',
    '{symbolic}': '#+=',
  },
};

export type TouchKeyboardMode = 'disabled' | 'popup' | 'fullscreen';

export type TouchKeyboardConfig = {
  debug?: boolean;
  openOnFocus?: boolean;
  mode?: TouchKeyboardMode;
  layoutName?: 'alphabetic' | 'numeric' | 'symbolic';
};

@Directive({
  standalone: true,
  selector: 'input[brtTouchKeyboard], textarea[brtTouchKeyboard]',
  exportAs: 'brtTouchKeyboard',
})
export class TouchKeyboardDirective implements OnInit, OnDestroy {
  private _overlay = inject(Overlay);
  private _elementRef = inject(ElementRef<HTMLInputElement>);
  private _cdr = inject(ChangeDetectorRef);

  config = input<TouchKeyboardConfig | undefined>(undefined, { alias: 'brtTouchKeyboard', });

  open = model(false, { alias: 'brtTouchKeyboardOpen', });
  locale = defaultLocale;

  private _overlayRef: OverlayRef | null = null;
  private _panelRef: ComponentRef<TouchKeyboardComponent> | null = null;

  constructor() {
    effect(() => {
      this.open() ? this.openPanel() : this.closePanel();
    });
  }

  ngOnInit(): void {
    if (this.config()?.mode === 'disabled') return;
    if (this.config()?.openOnFocus) {
      this._elementRef.nativeElement.addEventListener('focus', () => {
        this.open.set(true);
        this._cdr.detectChanges();
      });
    }
  }

  ngOnDestroy(): void {
    // Dispose overlay
    if (this._overlayRef) {
      this._overlayRef.dispose();
      this._overlayRef = null;
    }

    // Clear panel reference
    this._panelRef = null;
  }

  openPanel(): void {
    if (this._overlayRef?.hasAttached()) return;

    if (!this._overlayRef) this._createOverlay();

    if (this.config()?.mode === 'fullscreen') this._overlayRef!.addPanelClass('brt-touch-keyboard-fullScreen');
    else this._overlayRef!.removePanelClass('brt-touch-keyboard-fullScreen');

    // Update position the overlay
    this._overlayRef!.updatePositionStrategy(this._getPositionStrategy(this.config()?.mode));

    // Update size the overlay
    this._overlayRef!.updateSize(this._getOverlaySize(this.config()?.mode));

    // Attach the portal to the overlay
    this._panelRef = this._overlayRef!.attach(new ComponentPortal(TouchKeyboardComponent));
    this._panelRef.instance.debug = this.config()?.debug || false;
    // this._panelRef.instance.setLocale(this.locale());
    this._panelRef.instance.setActiveInput(this._elementRef.nativeElement, this.config());
    this._panelRef.instance.closePanel.subscribe(() => this.closePanel());
    this.open.set(true);
  }

  closePanel(): void {
    this._overlayRef?.detach();
    this.open.set(false);
  }

  togglePanel(): void {
    if (this.open()) {
      this.closePanel();
    } else {
      this.openPanel();
    }
  }

  private _createOverlay(): void {
    this._overlayRef = this._overlay.create({
      direction: 'ltr',
      hasBackdrop: false,
      panelClass: 'brt-touch-keyboard-overlay-pane',
      scrollStrategy: this._overlay.scrollStrategies.noop(),
    });
  }

  private _getPositionStrategy(mode: TouchKeyboardMode): PositionStrategy {
    if (mode === 'fullscreen') {
      return this._overlay.position().global().centerHorizontally().bottom('0');
    }

    return this._overlay
      .position()
      .flexibleConnectedTo(this._getOriginElement())
      .withLockedPosition()
      .withPush()
      .withPositions([
        { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top', },
        { originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom', },
        { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', },
        { originX: 'end', originY: 'top', overlayX: 'end', overlayY: 'bottom', },
      ]);
  }

  private _getOverlaySize(mode?: TouchKeyboardMode): OverlaySizeConfig {
    if (mode === 'fullscreen')
      return { width: '100%', maxWidth: '100%', minWidth: '100%', };
    else
      return {
        width: this._getOriginElement().getBoundingClientRect().width,
        maxWidth: this._getOriginElement().getBoundingClientRect().width,
        minWidth: '260px',
      };
  }

  private _getOriginElement(): any {

    const element = this._elementRef.nativeElement;

    // Material form field > v14
    if (element.classList.contains('mat-mdc-input-element'))
      return element.parentNode?.parentNode?.parentNode;

    // Return input
    return element;
  }
}


@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'brt-touch-keyboard',
  templateUrl: './touch-keyboard.component.html',
  styleUrl: './touch-keyboard.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TouchKeyboardComponent implements OnDestroy {
  private _sanitizer = inject(DomSanitizer);
  private _elementRef = inject(ElementRef<HTMLInputElement>);

  locale: Locale = defaultLocale;
  layoutMode = 'text';
  layoutName = 'alphabetic';
  debug = false;

  closePanel = output<void>();

  private _activeButtonClass = 'active';
  private _holdInteractionTimeout: number | null = null;
  private _holdTimeout: number | null = null;
  private _isMouseHold = false;
  private _caretPosition: number | null = null;
  private _caretPositionEnd: number | null = null;
  private _activeInput: HTMLInputElement | HTMLTextAreaElement | null = null;

  ngOnDestroy(): void {
    // Clean up timeouts
    if (this._holdInteractionTimeout) {
      clearTimeout(this._holdInteractionTimeout);
      this._holdInteractionTimeout = null;
    }
    if (this._holdTimeout) {
      clearTimeout(this._holdTimeout);
      this._holdTimeout = null;
    }

    // Clear active input reference
    this._activeInput = null;
  }

  get maxLength(): number {
    return this._activeInput?.maxLength ?? -1;
  }

  get isTextarea(): boolean {
    return this._activeInput?.type === 'textarea';
  }

  @HostListener('window:keyup', ['$event'])
  handleKeyUp(event: KeyboardEvent): void {
    if (!event.isTrusted || !this._activeInput) return;

    try {
      this._caretEventHandler(event);
      this._handleHighlightKeyUp(event);
    } catch (error) {
      console.error('TouchKeyboard: Error in handleKeyUp', error);
    }
  }

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent): void {
    if (!event.isTrusted || !this._activeInput) return;

    try {
      this._handleHighlightKeyDown(event);
    } catch (error) {
      console.error('TouchKeyboard: Error in handleKeyDown', error);
    }
  }

  // On pointerup (mouseup or touchend)
  @HostListener('window:pointerup', ['$event'])
  handleMouseUp(event: PointerEvent): void {
    if (!this._activeInput) return;

    try {
      this._caretEventHandler(event);
    } catch (error) {
      console.error('TouchKeyboard: Error in handleMouseUp', error);
    }
  }

  @HostListener('window:select', ['$event'])
  handleSelect(event: Event): void {
    if (!this._activeInput) return;

    try {
      this._caretEventHandler(event);
    } catch (error) {
      console.error('TouchKeyboard: Error in handleSelect', error);
    }
  }

  @HostListener('window:selectionchange', ['$event'])
  handleSelectionChange(event: Event): void {
    if (!this._activeInput) return;

    try {
      this._caretEventHandler(event);
    } catch (error) {
      console.error('TouchKeyboard: Error in handleSelectionChange', error);
    }
  }

  setLocale(value: Locale = defaultLocale): void {
    if (!(value && value.layouts)) throw new Error('Locale is not defined');
    this.locale = value;
  }

  setActiveInput(input: HTMLInputElement | HTMLTextAreaElement, config: TouchKeyboardConfig): void {
    this._activeInput = input;

    // Tracking keyboard layout
    // const inputMode = this._activeInput?.inputMode;
    // if (inputMode && ['text', 'search', 'email', 'url', 'numeric', 'decimal', 'tel'].some((i) => i === inputMode)) {
    //   this.layoutMode = inputMode;
    // } else {
    //   this.layoutMode = 'text';
    // }

    // if (inputMode && ['numeric', 'decimal', 'tel'].some((i) => i === inputMode)) {
    //   this.layoutName = 'default';
    // } else {
    //   this.layoutName = 'alphabetic';
    // }

    this.layoutName = config?.layoutName || 'alphabetic';

    if (this.debug) {
      console.log('Locale:', `${this.locale.code}`);
      console.log('Layout:', `${this.layoutMode}_${this.layoutName}`);
    }

    // we must ensure caretPosition doesn't persist once reactivated.
    this._setCaretPosition(this._activeInput.selectionStart, this._activeInput.selectionEnd);

    if (this.debug) {
      console.log('Caret start at:', this._caretPosition, this._caretPositionEnd);
    }

    // And set focus to input
    this._focusActiveInput();
  }

  isStandardButton = (button: string) => button && !(button[0] === '{' && button[button.length - 1] === '}');

  getButtonType(button: string): 'standard-key' | 'function-key' {
    return this.isStandardButton(button) ? 'standard-key' : 'function-key';
  }

  getButtonClass(button: string): string {
    const buttonTypeClass = this.getButtonType(button);
    const buttonWithoutBraces = button.replace('{', '').replace('}', '');
    let buttonNormalized = '';

    if (buttonTypeClass !== 'standard-key') buttonNormalized = `${buttonWithoutBraces}-key`;

    return `${buttonTypeClass} ${buttonNormalized}`;
  }

  getButtonDisplayName(button: string): SafeHtml {
    return this._sanitizer.bypassSecurityTrustHtml(this.locale.display[button] || button);
  }

  handleButtonPress(button: string, e?: Event): void {
    if (this.debug) {
      console.log('Key press:', button);
    }

    if (button === fnButton.SHIFT) {
      this.layoutName = this.layoutName === 'alphabetic' ? 'shift' : 'alphabetic';
      return;
    } else if (button === fnButton.DONE) {
      this.closePanel.emit();
      return;
    }

    const commonParams: [number, number, boolean] = [this._caretPosition || 0, this._caretPositionEnd || 0, true];
    let output = this._activeInput?.value || '';

    // Handel functional button
    if (!this.isStandardButton(button)) {
      if (button === fnButton.BACKSPACE) output = this._removeAt(output, ...commonParams);
      else if (button === fnButton.SPACE) output = this._addStringAt(output, ' ', ...commonParams);
      else if (button === fnButton.TAB) output = this._addStringAt(output, '\t', ...commonParams);
      else if (button === fnButton.ENTER) {
        if (this.isTextarea) {
          output = this._addStringAt(output, '\n', ...commonParams);
        }
      }
      // Handel LAYOUT
      else {
        this.layoutName = button.substring(1, button.length - 1);
        return;
      }
    }
    // Handel standard button
    else {
      output = this._addStringAt(output, button, ...commonParams);
    }

    if (this._activeInput) {
      this._activeInput.value = output;

      if (this.debug) {
        console.log('Caret at:', this._caretPosition, this._caretPositionEnd, 'Button', e);
      }
    }

    this._dispatchEvents(button);
  }

  handleButtonDown(button: string, e?: Event): void {
    if (this.debug) {
      console.log('Key down:', button);
    }

    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    this._setActiveButton(button);

    if (this._holdInteractionTimeout) {
      clearTimeout(this._holdInteractionTimeout);
      this._holdInteractionTimeout = null;
    }
    if (this._holdTimeout) {
      clearTimeout(this._holdTimeout);
      this._holdTimeout = null;
    }
    this._isMouseHold = true;

    // Time to wait until a key hold is detected
    this._holdTimeout = window.setTimeout(() => {
      if (
        this._isMouseHold &&
        ((!button.includes('{') && !button.includes('}')) || button === fnButton.BACKSPACE || button === fnButton.SPACE)
      ) {
        if (this.debug) {
          console.log('Button hold:', button);
        }
        this.handleButtonHold(button);
      }
      if (this._holdTimeout) {
        clearTimeout(this._holdTimeout);
        this._holdTimeout = null;
      }
    }, 500);

    // Handle button Click after button down
    this.handleButtonPress(button, e);
  }

  handleButtonUp(button: string, e?: Event): void {
    if (this.debug) {
      console.log('Key up:', button);
    }

    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    this._removeActiveButton();

    this._isMouseHold = false;
    if (this._holdInteractionTimeout) {
      clearTimeout(this._holdInteractionTimeout);
      this._holdInteractionTimeout = null;
    }
  }

  handleButtonHold(button: string): void {
    if (this._holdInteractionTimeout) {
      clearTimeout(this._holdInteractionTimeout);
      this._holdInteractionTimeout = null;
    }

    // Timeout dictating the speed of key hold iterations
    this._holdInteractionTimeout = window.setTimeout(() => {
      if (this._isMouseHold) {
        this.handleButtonPress(button);
        this.handleButtonHold(button);
      } else {
        if (this._holdInteractionTimeout) {
          clearTimeout(this._holdInteractionTimeout);
          this._holdInteractionTimeout = null;
        }
      }
    }, 100);
  }

  private _setCaretPosition(position: number | null, endPosition = position): void {
    this._caretPosition = position;
    this._caretPositionEnd = endPosition;
  }

  private _updateCaretPos(length: number, minus = false) {
    const newCaretPos = this._updateCaretPosAction(length, minus);
    this._setCaretPosition(newCaretPos);
    // Scroll to bottom
    setTimeout(() => {
      this._activeInput?.scrollTo({
        top: this._activeInput.scrollHeight,
      } as ScrollToOptions);
    });
  }

  private _updateCaretPosAction(length: number, minus = false) {
    let caretPosition = this._caretPosition;

    if (caretPosition != null) {
      if (minus) {
        if (caretPosition > 0) caretPosition = caretPosition - length;
      } else {
        caretPosition = caretPosition + length;
      }
    }

    return caretPosition;
  }

  private _removeAt(source: string, position = source.length, positionEnd = source.length, moveCaret = false) {
    if (position === 0 && positionEnd === 0) {
      return source;
    }

    let output;

    if (position === positionEnd) {
      let prevTwoChars;
      let emojiMatched;
      const emojiMatchedReg = /([\uD800-\uDBFF][\uDC00-\uDFFF])/g;

      /**
       * Emojis are made out of two characters, so we must take a custom approach to trim them.
       * For more info: https://mathiasbynens.be/notes/javascript-unicode
       */
      if (position && position >= 0) {
        prevTwoChars = source.substring(position - 2, position);
        emojiMatched = prevTwoChars.match(emojiMatchedReg);

        if (emojiMatched) {
          output = source.substring(0, position - 2) + source.substring(position);
          if (moveCaret) this._updateCaretPos(2, true);
        } else {
          output = source.substring(0, position - 1) + source.substring(position);
          if (moveCaret) this._updateCaretPos(1, true);
        }
      } else {
        prevTwoChars = source.slice(-2);
        emojiMatched = prevTwoChars.match(emojiMatchedReg);

        if (emojiMatched) {
          output = source.slice(0, -2);
          if (moveCaret) this._updateCaretPos(2, true);
        } else {
          output = source.slice(0, -1);
          if (moveCaret) this._updateCaretPos(1, true);
        }
      }
    } else {
      output = source.slice(0, position) + source.slice(positionEnd);
      if (moveCaret) {
        this._setCaretPosition(position);
      }
    }

    return output;
  }

  private _addStringAt(
    source: string,
    str: string,
    position = source.length,
    positionEnd = source.length,
    moveCaret = false
  ) {
    if (this.maxLength !== -1 && source.length >= this.maxLength) {
      return source;
    }

    let output;

    if (!position && position !== 0) {
      output = source + str;
    } else {
      output = [source.slice(0, position), str, source.slice(positionEnd)].join('');
      if (moveCaret) this._updateCaretPos(str.length, false);
    }

    return output;
  }

  // Method to dispatch necessary keyboard events to current input element.
  // @see https://w3c.github.io/uievents/tools/key-event-viewer.html
  private _dispatchEvents(button: string) {
    let key, code;
    if (button.includes('{') && button.includes('}')) {
      // Capitalize name
      key = button.slice(1, button.length - 1).toLowerCase();
      key = key.charAt(0).toUpperCase() + key.slice(1);
      code = key;
    } else {
      key = button;
      code = Number.isInteger(Number(button)) ? `Digit${button}` : `Key${button.toUpperCase()}`;
    }

    const eventInit: KeyboardEventInit = {
      bubbles: true, cancelable: true, shiftKey: this.layoutName == 'shift',
      key: key, code: code, location: 0,
    };

    // Simulate all needed events on base element
    this._activeInput?.dispatchEvent(new KeyboardEvent('keydown', eventInit));
    this._activeInput?.dispatchEvent(new KeyboardEvent('keypress', eventInit));
    this._activeInput?.dispatchEvent(new Event('input', { bubbles: true }));
    this._activeInput?.dispatchEvent(new KeyboardEvent('keyup', eventInit));

    // And set focus to input
    this._focusActiveInput();
  }

  private _caretEventHandler(event: any) {
    if (!this._activeInput) {
      return; // Exit early if no active input
    }

    let targetTagName = '';
    if (event.target?.tagName) {
      targetTagName = event.target.tagName.toLowerCase();
    }

    const isTextInput =
      targetTagName === 'textarea' ||
      (targetTagName === 'input' && ['text', 'search', 'email', 'password', 'url', 'tel'].includes(event.target?.type));

    const isKeyboard =
      event.target === this._elementRef.nativeElement ||
      (event.target && this._elementRef.nativeElement.contains(event.target));

    if (isTextInput && this._activeInput == event.target) {
      // Tracks current cursor position: As keys are pressed, text will be added/removed at that position within the input.
      this._setCaretPosition(event.target.selectionStart, event.target.selectionEnd);

      if (this.debug)
        console.log('Caret at:', this._caretPosition, this._caretPositionEnd, event && event.target.tagName.toLowerCase(), event);

    } else if (event.type === 'pointerup' && this._activeInput === document.activeElement) {
      if (this._isMouseHold) {
        this.handleButtonUp('');
      }
      return;
    } else if (!isKeyboard && event?.type !== 'selectionchange') {
      // we must ensure caretPosition doesn't persist once reactivated.
      this._setCaretPosition(null);

      if (this.debug)
        console.log(`Caret position reset due to "${event?.type}" event`, event);

      this.closePanel.emit();
    }
  }

  private _focusActiveInput(): void {
    this._activeInput?.focus();
    if (this._activeInput?.setSelectionRange && this._activeInput?.selectionStart != null)
      this._activeInput?.setSelectionRange(this._caretPosition, this._caretPositionEnd);
  }

  private _handleHighlightKeyDown(event: KeyboardEvent): void {
    const buttonPressed = this._getKeyboardLayoutKey(event);
    this._setActiveButton(buttonPressed);
  }

  private _handleHighlightKeyUp(event: KeyboardEvent): void {
    const buttonPressed = this._getKeyboardLayoutKey(event);
    this._removeActiveButton(buttonPressed);
  }

  // Transforms a KeyboardEvent's "key.code" string into a virtual-keyboard layout format
  private _getKeyboardLayoutKey(event: KeyboardEvent) {
    let output = '';
    const keyId = event.code || event.key;

    if (
      keyId?.includes('Space') ||
      keyId?.includes('Numpad') ||
      keyId?.includes('Backspace') ||
      keyId?.includes('CapsLock') ||
      keyId?.includes('Meta')
    ) {
      output = `{${event.code}}` || '';
    } else if (keyId?.includes('Control') || keyId?.includes('Shift') || keyId?.includes('Alt')) {
      output = `{${event.key}}` || '';
    } else {
      output = event.key || '';
    }

    return output.length > 1 ? output?.toLowerCase() : output;
  }

  private _setActiveButton(buttonName: string): void {
    const node = this._elementRef.nativeElement.getElementsByTagName('button').namedItem(buttonName);
    if (node && node.classList) {
      node.classList.add(this._activeButtonClass);
    }
  }

  private _removeActiveButton(buttonName?: string): void {
    const nodes = this._elementRef.nativeElement.getElementsByTagName('button');
    if (buttonName) {
      const node = nodes.namedItem(buttonName);
      if (node && node.classList) {
        node.classList.remove(this._activeButtonClass);
      }
    } else {
      for (let i = 0; i < nodes.length; i++) {
        nodes[i].classList.remove(this._activeButtonClass);
      }
    }
  }
}
